import { render, staticRenderFns } from "./RoomsCrud.vue?vue&type=template&id=0e85e7d9"
import script from "./RoomsCrud.vue?vue&type=script&lang=js"
export * from "./RoomsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports